"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconExclamationPoint = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M35 51.38a2.67 2.67 0 0 0 2.66-2.5l4-39.56A2.67 2.67 0 0 0 39 6.49h-8a2.67 2.67 0 0 0-2.66 2.83l4 39.56a2.67 2.67 0 0 0 2.66 2.5z"
  }), _react["default"].createElement("circle", {
    cx: "35",
    cy: "60.16",
    r: "4.87"
  })),
  height: undefined,
  width: undefined
});
IconExclamationPoint.displayName = 'IconExclamationPoint';
var _default = IconExclamationPoint;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/exclamation-point.js
// module id = 571
// module chunks = 0